export default __webpack_public_path__ + "static/media/icon_recurringDeposit.a7267f34.svg";